export class PropertyInfo {
    referenceName: string;
    optional: boolean;

    constructor(referenceName: string, optional = false) {
        this.referenceName = referenceName;
        this.optional = optional;
    }
}
